module.exports = __webpack_public_path__ + "img/CA.183fa575.svg";